import { Compass, ServerCrash } from "lucide-react";
import { Link, isRouteErrorResponse, useRouteError } from "react-router";

import { useDocumentTitle } from "../lib/hooks";
import { GridBackdrop } from "../ui/backdrop/GridBackdrop";
import { Button, buttonClass } from "../ui/Button";
import { EmptyState } from "../ui/Editing";
import styles from "./Fallbacks.module.css";

export function NotFound() {
  useDocumentTitle("Not found");
  return (
    <EmptyState
      icon={<Compass size={34} />}
      title="Nothing here"
      action={
        <Link to="/chat" className={buttonClass("primary")}>
          Back to chat
        </Link>
      }
    >
      This page does not exist. Use the menu to go to Chat, Dashboard or Settings.
    </EmptyState>
  );
}

export function RouteError() {
  const error = useRouteError();
  const message = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : "Unexpected error";
  return (
    <main className={styles.boot}>
      <GridBackdrop />
      <div className={styles.bootCard}>
        <ServerCrash size={40} aria-hidden="true" />
        <h1 className={styles.bootTitle}>Something broke</h1>
        <p className={styles.bootText} role="alert">
          {message}
        </p>
        <Button variant="primary" onClick={() => window.location.assign("/")}>
          Reload the app
        </Button>
      </div>
    </main>
  );
}
